export default __webpack_public_path__ + "static/media/reports_icon.c841d2bf.svg";